var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('header',{class:_vm.$style.header},[_vm._v(" Local Device Accounts ")]),_c('div',{class:_vm.$style.tableContainer},[_c('InsightsMultiItemTable',{attrs:{"exportEnabled":false,"filter":_vm.filter,"metricGroup":"users","systemId":_vm.item.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }